import { useEffect, useState } from 'react'
import { fetchLuckyWheelPlayConfig } from '../services/luckyWheelService'

/**
 * แสดงแท็บวงล้อมหาโชคเมื่อ platform เปิด + master switch + มีโหมด
 */
export function useLuckyWheelUserEntry(luckyWheelEnabled?: boolean) {
  const [userEntryVisible, setUserEntryVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      if (luckyWheelEnabled !== true) {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
        return
      }

      try {
        const res = await fetchLuckyWheelPlayConfig()
        if (!cancelled) {
          const visible = res.data?.userEntryVisible === true && (res.data?.modes?.length ?? 0) > 0
          setUserEntryVisible(visible)
          setChecked(true)
        }
      } catch {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [luckyWheelEnabled])

  return {
    showLuckyWheelEntry: luckyWheelEnabled === true && userEntryVisible,
    checked,
  }
}
